<template>
  <div v-show="newShowModel" id="contentPreview">
    <section class="coverPreview"></section>
    <div v-if="!forType" class="allPreview">
      <div class="imgPreview">
        <img src="../../assets/phone2.png"/>
        <div class="previewBody">
          <div style="overflow: hidden">
            <section class="d_flex font24"><span @click="cencelPreview()" class="c_p">×</span><span class="c_p">···</span></section>
            <nav class="arciNav">
              <p class="font16 f_w t_l" style="white-space: normal">{{contentDto.title}}</p>
              <p class="colorZh t_l">{{contentDto.contentEditor}} {{contentDto.publishDate}}</p>
            </nav>
            <!-- 正文 -->
            <div class="m_t_10" v-html="contentDto.content ? contentDto.content : contentDto.unionContent"></div>
            <!-- 审核编号、声明 -->
            <!--<div v-if="contentDto.auditNo || contentDto.declared" style="margin-top: 90px;margin-bottom: 100px;">-->
            <!--  <div style="margin-bottom: 10px;color:rgb(137,137,137);">-->
            <!--    <span>审核编号：</span>-->
            <!--    <span>{{contentDto.auditNo}}</span>-->
            <!--  </div>-->
            <!--  <div style="margin-bottom: 10px;color:rgb(137,137,137);">-->
            <!--    <span>声明：</span>-->
            <!--    <span>{{contentDto.declared}}</span>-->
            <!--  </div>-->
            <!--</div>-->
          </div>
        </div>
        <button class="cancelButton p_a" style="left: -120px;bottom: 30%;" @click="cencelPreview()">返回</button>
      </div>
    </div>
    <div v-if="forType === 'contentReadAll'">
      <div style="background-color: #fff;left: 5%;right: 5%;bottom:5%;top: 5%;border-radius: 10px" class="allPreview">
        <div style="position: absolute;top: 0;padding: 10px 0;font-size: 16px;border-bottom: 1px solid #eee; display: block;width: 100%;text-align: center">查看详情</div>
        <div style="position: absolute;left: 5%" class="imgPreview">
          <img src="../../assets/phone2.png"/>
          <div class="previewBody">
            <div style="overflow: hidden">
              <section class="d_flex font24"><span @click="cencelPreview()" class="c_p">×</span><span class="c_p">···</span></section>
              <nav class="arciNav">
                <p class="font16 f_w t_l" style="white-space: normal">{{contentDto.title}}</p>
                <p class="colorZh t_l">{{contentDto.contentEditor}} {{contentDto.publishDate}}</p>
              </nav>
              <div class="m_t_10" v-html="contentDto.content"></div>
              <!-- 审核编号、声明 -->
              <!--<div v-if="contentDto.auditNo || contentDto.declared" style="margin-top: 90px;margin-bottom: 100px;">-->
              <!--  <div style="margin-bottom: 10px;color:rgb(137,137,137);">-->
              <!--    <span>审核编号：</span>-->
              <!--    <span>{{contentDto.auditNo}}</span>-->
              <!--  </div>-->
              <!--  <div style="margin-bottom: 10px;color:rgb(137,137,137);">-->
              <!--    <span>声明：</span>-->
              <!--    <span>{{contentDto.declared}}</span>-->
              <!--  </div>-->
              <!--</div>-->
            </div>
          </div>
        </div>
        <div style="position: absolute;right: 5%;width: calc(90% - 400px);top: 50px;height: calc(100% - 120px);overflow: auto">
          <div style="display:flex; justify-content: space-between;">
            <div style="margin: 10px 0;text-align: left">
              <span class="f_w">微信推文总阅读次数：</span><span>{{readCountWechat}}</span>
            </div>
            <div style="margin: 10px 0;text-align: right">
              <span class="f_w">原文界面总点赞次数：</span><span>{{totalLikeCount}}</span> <span style="margin-left: 50px" class="f_w">原文界面总转发次数:</span> <span>{{totalFawordCount}}</span>
            </div>
          </div>
          <table cellspacing="0" class="allTable">
            <thead>
            <tr>
              <th>HCP姓名</th>
              <th>医院</th>
              <th>科室</th>
              <!-- <th>姓名</th> -->
              <th>阅读时长(s)</th>
              <th>转发次数</th>
              <th>是否收藏</th>
              <th>是否点赞</th>
            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in docViewList">
              <td>{{item.doctorName}}</td>
              <td style="max-width: 300px;white-space: normal">{{item.hospital}}</td>
              <td>{{item.dept}}</td>
              <!-- <th>姓名</th> -->
              <td>{{item.readTime}}</td>
              <td>{{item.forwards}}</td>
              <td>{{item.isFav ? '是' : '否'}}</td>
              <td>{{item.isLike ? '是' : '否'}}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <button class="redButtonTwo p_a" style="position: absolute;bottom:10px" @click="cencelPreview()">返回</button>
      </div>
    </div>
  </div>
</template>

<script>
import newPage from './page'
import '../../assets/js/jquery-2.0.0'
import '../../assets/js/audioplayer'
import '../../assets/css/videoAudio.css'
export default {
  name: 'page',
  model: {
    prop: 'newShowModel',
    event: 'newShowModel'
  },
  props: [
    'object',
    'contentId',
    'forType',
    'newShowModel',
    'allkind',
    'allNewKind'
  ],
  data () {
    return {
      token: window.sessionStorage.getItem('token'),
      baseUrl: process.env.config.baseUrl,
      CNmode: true,
      contentDto: {
        detailInfo: {}
      },
      newcontentId: this.contentId,
      docViewList: [],
      readCountWechat: '' // 微信推文总阅读次数
    }
  },
  created () { // vue 页面的生命周期 当我一进来页面之后 我先执行
  },
  mounted () { // vue 页面的生命周期 当我进来之后 且加载完资源了之后再执行
    this.getContentDetail()
    this.$nextTick(() => {
      // 初始化audio
      window.setTimeout(() => {
        if (!this.forType) {
          $( function() {
            $( 'audio' ).audioPlayer(
              {
                classPrefix: 'audioplayer',
                strPlay: 'Play',
                strPause: 'Pause',
                strVolume: 'Volume',
                title: '这是音频'
              }
            );
          });
        }
      }, 1000)
    })
  },
  methods: {
    getReadList () {
      this.$axiox.get('/api/ArticlDoctor/doctors/' + this.newcontentId).then(p => {
        console.log(p)
        this.docViewList = p
      })
    },
    changeType (type) {
      this.CNmode = type
    },
    getContentDetail () {
      if (this.newcontentId !== 0 && this.newcontentId !== undefined && this.newcontentId !== null && this.newcontentId !== '') {
        let url = ''
        if (this.allkind === 'material' || this.allNewKind === 'MaterialLibrary') {
          url = '/api/content/material?materialId=' + this.newcontentId
        } else {
          url = '/api/Article/' + this.newcontentId
        }
        this.$axiox.get(url).then(p => {
          console.log(p, 'content------preview')
          p.content = p.content.replace(/&lt;iframe/g, '<iframe').replace(/&gt;&lt;\/iframe&gt;/g, '></iframe>').replace(/&lt;source/g, '<source').replace(/\/&gt;/g, '/>')
          if (this.allkind === 'material' || this.allNewKind === 'MaterialLibrary') {
            this.contentDto.detailInfo = p || {}
          } else {
            this.contentDto = p || {}
          }
        })
      }
    },
    cencelPreview () {
      this.newcontentId = 0
      this.$emit('newShowModel', false)
    },
    getReadCountWechat () {
      this.$axiox.get(`api/ArticlDoctor/ReadCount/${this.newcontentId}`).then(res => {
        console.log(res, 'getReadCountWechat')
        this.readCountWechat = res
      })
    }
  },
  components: {
    'newPage': newPage
  },
  watch: {
    contentId (value) {
      this.newcontentId = value
      this.getContentDetail()
      if (this.forType === 'contentReadAll') {
        this.getReadList()
        this.getReadCountWechat()
      }
    }
  },
  computed: {
    totalLikeCount () {
      let num = 0
      for (let i = 0; i < this.docViewList.length; i++) {
        if (this.docViewList[i].isLike) {
          num++
        }
      }
      return num
    },
    totalFawordCount () {
      let num = 0
      for (let i = 0; i < this.docViewList.length; i++) {
        if (this.docViewList[i].forwards) {
          num += parseInt(this.docViewList[i].forwards)
        }
      }
      return num
    }
  }
}
</script>

<style scoped>
  .alltext{
    text-align: left!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/myComponents/contentPreview.vue